<template>
  <portal to="fullscreen" v-if="show">
    <div
      class="fullscreen-image backdrop"
      @click="$emit('hide')"
    >
      <div class="image-container">
        <img :src="image" :alt="label" />
      </div>

      <div class="actions-container">
        <btn
          v-if="hasBackImage"
          kind="flat"
          icon="360"
          @click.stop.prevent="$emit('flip')">
          Flip card
        </btn>
      </div>
    </div>
  </portal>
</template>

<script>
import Btn from './Btn';

export default {
  components: {
    Btn,
  },

  props: {
    show: Boolean,
    image: String,
    label: String,
    hasBackImage: Boolean,
  },

  mounted() {
    this.$bus.$on('keyboard-shortcut-esc', this.handleKeyboardEscape);
  },

  beforeDestroy() {
    this.$bus.$off('keyboard-shortcut-esc', this.handleKeyboardEscape);
  },

  watch: {
    show(value) {
      if (value) {
        document.body.classList.add('disable-scroll');
      } else {
        document.body.classList.remove('disable-scroll');
      }
    },
  },

  methods: {
    handleKeyboardEscape() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.fullscreen-image {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-container {
  flex: 1;
  overflow: hidden;
  padding: $gp * 1.5;
  padding-bottom: 0;

  img {
    max-height: 100%;
  }
}

.actions-container {
  padding: $gp;
  --theme-secondary-button-color: #{$color-white};
}
</style>
